import { InjectionToken } from '@angular/core';

/**
 * Конфигурация первопартийного SDK: куда шлём батчи (edge `/collect`), идентификатор
 * приложения и параметры батчинга/сессии. Значения по умолчанию годятся для основного
 * билда; регион-билды переопределяют токен в своём `app.config.ts`. URL относительный —
 * edge-воркер живёт на том же origin (проксируется), поэтому CORS не нужен.
 */
export interface IFirstPartyConfig {
    readonly collectUrl: string;
    readonly app: string;
    readonly maxBatchSize: number;
    readonly flushIntervalMs: number;
    readonly sessionIdleMs: number;
}

const DEFAULT_MAX_BATCH_SIZE: number = 20;
const DEFAULT_FLUSH_INTERVAL_MS: number = 10_000;
const DEFAULT_SESSION_IDLE_MS: number = 30 * 60 * 1000;

export const FIRST_PARTY_CONFIG: InjectionToken<IFirstPartyConfig> = new InjectionToken<IFirstPartyConfig>('FIRST_PARTY_CONFIG', {
    factory: (): IFirstPartyConfig => ({
        collectUrl: '/collect',
        app: 'com',
        maxBatchSize: DEFAULT_MAX_BATCH_SIZE,
        flushIntervalMs: DEFAULT_FLUSH_INTERVAL_MS,
        sessionIdleMs: DEFAULT_SESSION_IDLE_MS,
    }),
});
